import plugin from 'tailwindcss/plugin';

const noJsPlugin = plugin(({ addVariant }) => {
  addVariant('nojs', 'html.nojs &');
  addVariant('js', 'html:not(.nojs) &');
});

export default noJsPlugin;
